import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGenericCarbonConservative = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 7H7V12H11V11H13V12C13 13.1046 12.1046 14 11 14H7C5.89543 14 5 13.1046 5 12V7C5 5.89543 5.89543 5 7 5H11C12.1046 5 13 5.89543 13 7V8H11V7Z",
		fill: "black"
	})
});
export default SvgGenericCarbonConservative;
